<div
  class="relative w-full h-full bg-slate-50 flex flex-col overflow-auto font-prompt pb-32"
>
  <!-- 1. Header Bar (Dark Gradient VIP Theme) -->
  <div
    class="relative bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pt-6 pb-9 rounded-b-[2.5rem] shadow-lg z-20 shrink-0 text-white border-b border-white/5"
  >
    <!-- Header Top Row -->
    <div class="flex justify-between items-center px-6 mb-5 select-none">
      <div class="flex items-center gap-3">
        <!-- Back Button -->
        <!-- <button
          class="w-9 h-9 bg-slate-100 hover:bg-slate-200/80 shadow-sm rounded-full flex justify-center items-center active:scale-95 transition-all border border-slate-200/10 text-slate-700 outline-none"
          (click)="goback()">
          <img src="icons/arrow_back_black.svg" class="w-full h-full" />
        </button> -->

        <h1 class="text-white text-lg font-black tracking-wide leading-none">
          {{ currentLang === "TH" ? "รายการชาร์จ EV" : "EV Charging List" }}
        </h1>
      </div>

      <!-- Action Utilities -->
      <div class="flex gap-2.5 items-center">
        <!-- Invoices Link -->
        <div class="relative">
          <button
            (click)="goToNavigateInvoice()"
            class="w-9 h-9 bg-slate-100 hover:bg-slate-200/80 shadow-sm rounded-full flex items-center justify-center active:scale-95 transition-all border border-slate-200/10 text-slate-700 outline-none"
          >
            <img src="icons/receipt_long_black_soft.svg" />
          </button>
          <div
            *ngIf="countCityParkingInvoice.count > 0"
            class="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-[9px] text-white font-black border-2 border-white animate-bounce"
          >
            {{
              countCityParkingInvoice.count > 9
                ? "9+"
                : countCityParkingInvoice.count
            }}
          </div>
        </div>

        <!-- History Link -->
        <button
          (click)="goToNavigateHistory()"
          class="w-9 h-9 bg-slate-100 hover:bg-slate-200/80 shadow-sm rounded-full flex items-center justify-center active:scale-95 transition-all border border-slate-200/10 text-slate-700 outline-none"
        >
          <img src="icons/history_black_soft.svg" />
        </button>

        <!-- Reload Data Link -->
        <button
          (click)="onClickReload()"
          class="w-9 h-9 bg-slate-100 hover:bg-slate-200/80 shadow-sm rounded-full flex items-center justify-center active:scale-95 transition-all border border-slate-200/10 text-slate-700 outline-none"
        >
          <img src="icons/sync_black_soft.svg" />
        </button>
      </div>
    </div>

    <!-- 2. Wallet Balance Card (Floating Shadow style) -->
    <div
      class="mx-6 bg-white rounded-3xl p-4 shadow-md flex justify-between items-center border border-slate-100"
    >
      <div class="flex items-center gap-3 text-left">
        <div
          class="w-10 h-10 bg-white rounded-2xl flex items-center justify-center text-amber-500 shadow-[inset_0_0_3px_2px_rgba(0,0,0,0.1)] flex-shrink-0"
        >
          <img
            src="icons/charge-home-yellow.png"
            class="w-5 h-5 object-contain"
          />
        </div>
        <div class="flex flex-col">
          <span
            class="text-[10px] text-gray-500 font-bold block leading-none mb-1"
            >{{
              currentLang === "TH" ? "ยอดเงินคงเหลือ" : "Wallet Balance"
            }}</span
          >
          <span class="text-base font-black text-slate-800 leading-none">
            {{ topUpData.amount | number: "1.2-2" }}
            <span
              class="text-[9px] font-extrabold text-slate-400 tracking-wider"
              >THB</span
            >
          </span>
        </div>
      </div>

      <button
        class="bg-amber-400 hover:bg-amber-500 text-slate-800 text-xs font-black px-4 py-2.5 rounded-xl shadow-sm active:scale-95 transition-transform flex items-center gap-1 cursor-pointer border-none outline-none"
        (click)="goToNavigateTopup()"
      >
        <span class="font-extrabold text-sm">+</span>
        {{ currentLang === "TH" ? "เติมเงิน" : "Top up" }}
      </button>
    </div>
  </div>

  <!-- 3. Search and Categories Tab Segment -->
  <div class="px-6 -mt-3.5 z-30 flex flex-col gap-3">
    <!-- Category Filter Tabs -->
    <div class="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
      <button
        class="flex-1 py-2.5 px-4 rounded-full text-xs font-black shadow-sm transition-all whitespace-nowrap border-none cursor-pointer outline-none animate-fade-in"
        [ngClass]="
          statusFilter === 'all'
            ? 'bg-amber-400 text-slate-850'
            : 'bg-white text-slate-500 border border-slate-100'
        "
        (click)="toggleFilterEvCharger('all')"
      >
        {{ currentLang === "TH" ? "ทั้งหมด" : "All" }}
      </button>
      <button
        class="flex-1 py-2.5 px-4 rounded-full text-xs font-black shadow-sm transition-all whitespace-nowrap border-none cursor-pointer outline-none"
        [ngClass]="
          statusFilter === 'charging'
            ? 'bg-emerald-500 text-white'
            : 'bg-white text-slate-500 border border-slate-100'
        "
        (click)="toggleFilterEvCharger('charging')"
      >
        {{ currentLang === "TH" ? "กำลังชาร์จ" : "Charging" }}
      </button>
      <button
        class="flex-1 py-2.5 px-4 rounded-full text-xs font-black shadow-sm transition-all whitespace-nowrap border-none cursor-pointer outline-none"
        [ngClass]="
          statusFilter === 'parked'
            ? 'bg-slate-400 text-white'
            : 'bg-white text-slate-500 border border-slate-100'
        "
        (click)="toggleFilterEvCharger('parked')"
      >
        {{ currentLang === "TH" ? "จอดอยู่" : "Parked" }}
      </button>
    </div>

    <!-- Search Input (Feature Added: License Plate search filter) -->
    <div
      class="bg-white rounded-2xl shadow-sm border border-slate-100 p-2 flex items-center gap-2"
    >
      <div class="pl-2 text-slate-400">
        <img src="icons/search_slate.svg" />
      </div>
      <input
        type="text"
        [(ngModel)]="searchLicense"
        (input)="onSearchCharger()"
        placeholder="{{
          currentLang === 'TH'
            ? 'ค้นหาหมายเลขทะเบียน...'
            : 'Search license plate...'
        }}"
        class="w-full h-8 bg-transparent focus:outline-none text-slate-700 placeholder-slate-400 text-xs font-bold border-none"
      />
      <button
        *ngIf="searchLicense"
        (click)="onSearchClear()"
        class="w-7 h-7 flex items-center justify-center bg-slate-50 hover:bg-slate-100 rounded-lg text-slate-400 active:scale-95 transition-all outline-none border-none cursor-pointer"
      >
        <img src="icons/close_slate_dark.svg" class="w-full h-full" />
      </button>
    </div>
  </div>

  <!-- 4. Scanning Information Alert Banner -->
  <div class="px-6 mt-3 mb-1">
    <div
      class="bg-amber-500/[0.04] border border-amber-100 rounded-2xl px-3.5 py-3 flex gap-2.5 items-start text-left"
    >
      <img
        class="leading-none select-none"
        src="icons/contact_support_orange.svg"
      />
      <div class="space-y-0.5">
        <p class="text-amber-600 text-[10px] font-black leading-snug">
          {{
            currentLang === "TH"
              ? "ไม่พบรถ EV ของท่านในรายการ? กรุณาสแกน QR เพื่อสั่งชาร์จด้วยตนเอง"
              : "Can't find your EV in the list? Please scan QR to start charging manually."
          }}
        </p>
        <p class="text-slate-400 text-[9px] font-bold leading-snug">
          {{
            currentLang === "TH"
              ? "(เฉพาะสถานีที่ใช้กล้องตรวจจับทะเบียน — บางพื้นที่จำเป็นต้องสแกนเพื่อเริ่ม)"
              : "(Camera detection stations only — some zones require a QR scan to initialize)"
          }}
        </p>
      </div>
    </div>
  </div>

  <!-- 5. Scrollable Charger Transactions List -->
  <div class="flex-1 px-6 pb-28 space-y-3 mt-2">
    <!-- Empty State -->
    <div
      *ngIf="
        (filterParkingTransactionEVDto
          ? filterParkingTransactionEVDto
          : parkingTransactionEVDto
        ).length === 0
      "
      class="flex flex-col items-center justify-center py-20 text-slate-400 select-none"
    >
      <img class="mb-2" src="icons/ev_station_slate_dark.svg" />
      <p class="text-xs font-bold">
        {{
          currentLang === "TH"
            ? "ไม่พบรายการรถ EV ในขณะนี้"
            : "No active EV charging found"
        }}
      </p>
    </div>

    <!-- Charger Cards -->
    <div
      *ngFor="
        let charger of filterParkingTransactionEVDto
          ? filterParkingTransactionEVDto
          : parkingTransactionEVDto
      "
      (click)="goToNavigate(charger.historyUuid)"
      class="bg-white rounded-3xl p-4.5 shadow-sm border border-slate-100 relative group active:scale-[0.99] transition-all hover:shadow-md cursor-pointer flex gap-4 text-left"
    >
      <!-- Left Column: Charger Image & Space Code -->
      <div class="w-24 shrink-0 flex flex-col gap-2">
        <div
          class="h-20 bg-slate-50 rounded-2xl flex items-center justify-center p-3 border border-slate-100/50"
        >
          <img
            src="/icons/EV-charger/charger.png"
            class="w-full h-full object-contain mix-blend-multiply"
          />
        </div>
        <div
          class="bg-amber-50 text-amber-700 text-[10px] font-black text-center py-1 rounded-lg tracking-wider border border-amber-100/50"
        >
          {{ charger.spaceCode }}
        </div>
      </div>

      <!-- Right Column: Card Metadata details -->
      <div class="flex-1 flex flex-col justify-between min-w-0">
        <!-- Header row: plate and status badge -->
        <div class="flex justify-between items-start gap-2">
          <h3 class="text-sm font-black text-slate-800 leading-tight truncate">
            {{ charger.licensePlate }}
          </h3>

          <span
            class="text-[9px] font-black px-2 py-0.5 rounded-full flex items-center gap-1 shrink-0"
            [ngClass]="
              charger.status
                ? 'bg-emerald-50 text-emerald-600'
                : 'bg-slate-100 text-slate-500'
            "
          >
            <span
              class="w-1.5 h-1.5 rounded-full"
              [ngClass]="
                charger.status ? 'bg-emerald-500 animate-pulse' : 'bg-slate-400'
              "
            ></span>
            {{
              charger.status
                ? currentLang === "TH"
                  ? "กำลังชาร์จ"
                  : "Charging"
                : currentLang === "TH"
                  ? "จอดอยู่"
                  : "Parked"
            }}
          </span>
        </div>

        <!-- Meta Details row -->
        <div class="space-y-1.5 mt-2">
          <!-- Station Location -->
          <p
            class="text-[10px] text-slate-500 font-bold flex items-center gap-1 leading-none"
          >
            <img src="icons/distance_slate_dark.svg" class="w-5 h-5" />
            <span class="truncate">{{ charger.siteName }}</span>
          </p>
          <!-- Kwh -->
          <div
            class="flex items-center gap-2.5 text-[10px] text-slate-500 font-bold leading-none"
          >
            <span class="flex items-center gap-1">
              <img src="icons/bolt_boost_slate_dark.svg" class="w-5 h-5" />
              <span>{{ charger.chargingKwh }} kWh</span>
            </span>
          </div>
          <!-- Timeline duration details -->
          <div
            class="flex items-center gap-2.5 text-[10px] text-slate-500 font-bold leading-none"
          >
            <span class="flex items-center gap-1">
              <img src="icons/schedule_slate_dark.svg" class="w-5 h-5" />
              <span *ngIf="hour(charger.totalTime) >= 1"
                >{{ hour(charger.totalTime) }} hr</span
              >
              <span>{{ charger.totalTime % 60 }} min</span>
            </span>
            <span class="text-slate-200">|</span>
            <span class="font-mono">{{
              charger.enterAt | date: "dd/MM HH:mm"
            }}</span>
          </div>
        </div>

        <!-- Billing Summary footer -->
        <div
          class="mt-2.5 pt-2 border-t border-dashed border-slate-100 flex justify-between items-end"
        >
          <div class="min-w-0">
            <span
              class="text-[9px] text-slate-400 font-bold block leading-none"
            >
              {{ currentLang === "TH" ? "อัตราค่าบริการ" : "Rate" }}
            </span>
            <span
              class="font-mono text-slate-500 font-bold text-[10px] mt-0.5 block leading-none"
            >
              {{ charger.fee || "-" }} THB/hr
            </span>
          </div>
          <div class="text-right">
            <span
              class="text-[9px] text-slate-400 font-bold block leading-none"
            >
              {{ currentLang === "TH" ? "ยอดเงินสะสม" : "Accrued" }}
            </span>
            <span
              class="text-sm font-black text-rose-600 leading-none mt-0.5 block"
            >
              ฿{{ charger.price | number: "1.2-2" }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 6. Scan QR — centered CTA -->
  <div
    class="fixed bottom-24 left-0 right-0 z-50 flex justify-center px-4 pointer-events-none pb-1"
  >
    <button
      type="button"
      (click)="openScanQrModal()"
      class="pointer-events-auto inline-flex items-center justify-center gap-2.5 min-h-12 px-5 py-3 rounded-full bg-(--main-color) text-slate-800 shadow-lg shadow-amber-400/30 active:scale-95 transition-all hover:scale-[1.02] border-none outline-none cursor-pointer max-w-[min(100%,320px)]"
      [attr.aria-label]="
        currentLang === 'TH'
          ? 'สแกนเพื่อเริ่มต้นใช้งาน'
          : 'Scan to start charging'
      "
      [title]="
        currentLang === 'TH'
          ? 'สแกนเพื่อเริ่มต้นใช้งาน'
          : 'Scan to start charging'
      "
    >
      <img
        src="icons/qr_code_scanner_black.svg"
        class="w-6 h-6 shrink-0"
        alt=""
      />
      <span class="text-sm font-extrabold leading-tight text-left">
        {{
          currentLang === "TH"
            ? "สแกนเพื่อเริ่มต้นใช้งาน"
            : "Scan to start charging"
        }}
      </span>
    </button>
  </div>

  <app-pss-loading *ngIf="isLoading"></app-pss-loading>
</div>

<app-modal-ev-charger-scan-qr
  *ngIf="isShowScanQrModal"
  (closeModal)="closeScanQrModal()"
  (save)="handleScanResult($event.messageAPI, $event.evEntriesByQRCode)"
></app-modal-ev-charger-scan-qr>
